import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetLeagueQuery, useGetLeagueMatchesQuery } from '../api';
import { leagueActions } from '../slice';
import { POLLING_INTERVAL } from '../consts';

export const useLeaguePolling = (leagueId: string) => {
  const dispatch = useDispatch();

  const {
    data: leagueData,
    error: leagueError,
    isLoading: leagueLoading,
    isFetching: leagueFetching,
  } = useGetLeagueQuery({ league_id: leagueId }, { skip: !leagueId });

  const {
    data: matchesData,
    error: matchesError,
    isLoading: matchesLoading,
    isFetching: matchesFetching,
  } = useGetLeagueMatchesQuery(
    { league_id: leagueId },
    { skip: !leagueData, pollingInterval: POLLING_INTERVAL },
  );

  useEffect(() => {
    if (leagueData) dispatch(leagueActions.setLeague(leagueData));
  }, [leagueData, dispatch]);

  useEffect(() => {
    if (!matchesFetching && matchesData) {
      dispatch(leagueActions.setLeagueMatches(matchesData));
    }
  }, [matchesFetching, matchesData, dispatch]);

  return {
    leagueData,
    leagueError,
    leagueLoading,
    matchesData,
    matchesError,
    matchesLoading,
    loading: leagueLoading || matchesLoading,
    error: leagueError || matchesError,
  };
};
